var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEducationIcon4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 162.7 162.7",
    style: {
      enableBackground: "new 0 0 162.7 162.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#F9D8D9;stroke:#3B3C3C;stroke-width:5.6693;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st2{fill:#FBE6E7;stroke:#3B3C3C;stroke-width:5.6693;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#3B3C3C;stroke-width:2.8346;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st4{fill:#3B3C3C;}\n\t.st5{fill:#54494B;stroke:#3B3C3C;stroke-width:5.6693;stroke-linecap:round;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.15
    },
    width: 169,
    height: 169,
    xlinkHref: "DB0697BF7B6EE331.png",
    transform: "matrix(1 0 0 1 -3.5039 -0.8039)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 81.2,
    cy: 81.2,
    r: 75.6
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 123.7,
    cy: 102.2,
    rx: 11.9,
    ry: 13.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 38.6,
    cy: 102.6,
    rx: 11.9,
    ry: 13.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M122,78.3L122,78.3c0-20.1-18.5-36.4-41.3-36.4S39.4,58.2,39.4,78.3v17.5l0,0c0.1,20,18.6,36.2,41.3,36.2 s41.2-16.2,41.3-36.2l0,0V78.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M85.5,112.3c0,0-0.1-3.3-5-3.3s-4.8,3.3-4.8,3.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M57.7,85.9c2.2-2.6,6.1-3.7,10-2.5c3.2,0.9,5.6,3.1,6.7,5.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M103.8,86.1c-2.1-2.6-6-3.8-10-2.8c-3.2,0.8-5.7,2.9-6.8,5.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 68.3,
    cy: 95.5,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 93.2,
    cy: 95.5,
    r: 3.9
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M42.8,76.2c0,0,2.8,5.2,10.3,4.5s15.1-8.9,15.1-8.9s1.8,4.6,6.8,4.6c4.9,0,6.5-4.6,6.5-4.6s0.5,4.3,5.5,4.3 c5.1,0,7.8-4.3,7.8-4.3s6.6,9.1,14.1,9.1s11.4-6,11.4-6v16.6c4.6-6.1,7.2-13.4,7.2-21.2c0-22-20.9-39.9-46.8-39.9 S33.9,48.1,33.9,70.1c0,8.7,3.3,16.8,8.9,23.4V76.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M73.1,106.7h-9.7c-0.8,0-1.5-0.7-1.5-1.5v-2.9c0-0.8,0.7-1.5,1.5-1.5h9.7c0.8,0,1.5,0.7,1.5,1.5v2.9 C74.6,106,73.9,106.7,73.1,106.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M98,106.7h-9.7c-0.8,0-1.5-0.7-1.5-1.5v-2.9c0-0.8,0.7-1.5,1.5-1.5H98c0.8,0,1.5,0.7,1.5,1.5v2.9 C99.5,106,98.9,106.7,98,106.7z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationIcon4);
export default __webpack_public_path__ + "static/media/Education-Icon_4.9c89072fee108e49ecbea4ce37266793.svg";
export { ForwardRef as ReactComponent };